/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Ical_MissingInputs */

const cs_settings_profile_ical_missing = /** @type {(inputs: Settings_Profile_Ical_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iCal URL se nepodařilo načíst.`)
};

const en_settings_profile_ical_missing = /** @type {(inputs: Settings_Profile_Ical_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load iCal URL.`)
};

/**
* | output |
* | --- |
* | "Could not load iCal URL." |
*
* @param {Settings_Profile_Ical_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_ical_missing = /** @type {((inputs?: Settings_Profile_Ical_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Ical_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_ical_missing(inputs)
	return cs_settings_profile_ical_missing(inputs)
});